import { Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";

export const TabsNavigation = () => {
  const [selected, setSelected] = useState<string | undefined>(undefined);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelected(newValue);
  };

  useEffect(() => {
    if (selected) {
      const element = document.getElementById(selected);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [selected]);

  return (
    <Tabs value={selected} onChange={handleChange} textColor="primary">
      <Tab
        label="About Me"
        value="aboutMe"
        sx={{ textTransform: "capitalize" }}
      />
      <Tab
        label="Work Experience"
        value="workExperience"
        sx={{ textTransform: "capitalize" }}
      />
      <Tab
        label="Projects"
        value="projects"
        sx={{ textTransform: "capitalize" }}
      />
      <Tab
        label="Other Languages"
        value="otherLanguages"
        sx={{ textTransform: "capitalize" }}
      />
    </Tabs>
  );
};
